import { string } from 'yup'

const ConfirmPasswordField = (refs, message) => string().oneOf(refs, message || 'Your passwords must match')

export default ConfirmPasswordField
